<span class="text-3xl">{{ 'biAnalysis.title' | translate }}</span>

<p>{{ 'biAnalysis.description' | translate }}</p>
<button
  kendoButton
  themeColor="primary"
  class="uppercase"
  maximizerShowcaseBookDemo
>
  {{ 'biAnalysis.button.action' | translate }}
</button>
